import { getCurrencySymbol } from 'modules/core/lib/formatCurrency'
import i18n from 'modules/core/lib/i18n'

const UNKNOWN = '–'
const MONEY = 'money'
const UNITS = 'units'

export function formatUnit(value: any) {
  switch (value) {
    case MONEY:
      return getCurrencySymbol()

    case UNITS:
      return i18n.t('handoffs.supplements.units.units')

    default:
      return value
  }
}

export function formatAmount(value: any) {
  if (value === UNKNOWN) return UNKNOWN

  return i18n.formatNumber(value / 100)
}
